// src/config/categories.js

import {
  // Food & Drinks
  Utensils,
  Coffee,
  Wine,
  GlassWater,
  Cake,
  Truck,
  
  // Entertainment
  Radio,
  Guitar,
  Headphones,
  Music,
  Hammer,
  Target,
  Gamepad2,
  
  // Vendors & Business
  ShoppingBag,
  Store,
  ShoppingCart,
  Store as Booth,
  Building,
  Palette,
  Image,
  
  // Experience
  Armchair,
  Palmtree,
  Crown,
  Camera,
  Zap,
  Handshake,
  
  // Family
  Baby,
  Home,
  
  // Services
  CircleUserRound,  // ✨ Best toilet/restroom icon available
  Stethoscope,
  Shield,
  Info,
  Droplet,
  Search,
  
  // Navigation
  DoorOpen,
  DoorClosed,
  ParkingSquare,
  Bus,
  Ticket,
  Star,
  
  // Fallback
  MapPin
} from 'lucide-react';

export const CATEGORY_CONFIG = {
  // ============================================
  // FOOD & DRINKS
  // ============================================
  food: {
    label: 'Food',
    emoji: '🍕',
    icon: Utensils,
    color: '#FF6347',
    group: 'Food & Drinks'
  },
  drinks: {
    label: 'Drinks',
    emoji: '🥤',
    icon: GlassWater,
    color: '#4FC3F7',
    group: 'Food & Drinks'
  },
  alcohol: {
    label: 'Alcohol',
    emoji: '🍺',
    icon: Wine,
    color: '#FFA726',
    group: 'Food & Drinks'
  },
  coffee: {
    label: 'Coffee',
    emoji: '☕',
    icon: Coffee,
    color: '#6D4C41',
    group: 'Food & Drinks'
  },
  dessert: {
    label: 'Dessert',
    emoji: '🍰',
    icon: Cake,
    color: '#F48FB1',
    group: 'Food & Drinks'
  },
  food_truck: {
    label: 'Food Truck',
    emoji: '🚚',
    icon: Truck,
    color: '#FF8A65',
    group: 'Food & Drinks'
  },

  // ============================================
  // ENTERTAINMENT
  // ============================================
  stage: {
    label: 'Stage',
    emoji: '🎭',
    icon: Radio,
    color: '#9C27B0',
    group: 'Entertainment'
  },
  live_music: {
    label: 'Live Music',
    emoji: '🎸',
    icon: Guitar,
    color: '#AB47BC',
    group: 'Entertainment'
  },
  dj: {
    label: 'DJ',
    emoji: '🎧',
    icon: Headphones,
    color: '#7B1FA2',
    group: 'Entertainment'
  },
  music: {
    label: 'Music',
    emoji: '🎵',
    icon: Music,
    color: '#8E24AA',
    group: 'Entertainment'
  },
  performance: {
    label: 'Performance',
    emoji: '🎪',
    icon: Radio,
    color: '#E91E63',
    group: 'Entertainment'
  },
  workshop: {
    label: 'Workshop',
    emoji: '🛠️',
    icon: Hammer,
    color: '#FF7043',
    group: 'Entertainment'
  },
  activity: {
    label: 'Activity',
    emoji: '🎯',
    icon: Target,
    color: '#FF9800',
    group: 'Entertainment'
  },
  game_zone: {
    label: 'Game Zone',
    emoji: '🎮',
    icon: Gamepad2,
    color: '#00BCD4',
    group: 'Entertainment'
  },

  // ============================================
  // VENDORS & BUSINESS
  // ============================================
  merch: {
    label: 'Merchandise',
    emoji: '🛍️',
    icon: ShoppingBag,
    color: '#795548',
    group: 'Vendors & Business'
  },
  market: {
    label: 'Market',
    emoji: '🏪',
    icon: Store,
    color: '#8D6E63',
    group: 'Vendors & Business'
  },
  popup_shop: {
    label: 'Pop-up Shop',
    emoji: '🏬',
    icon: ShoppingCart,
    color: '#A1887F',
    group: 'Vendors & Business'
  },
  brand_booth: {
    label: 'Brand Booth',
    emoji: '🎪',
    icon: Booth,
    color: '#6D4C41',
    group: 'Vendors & Business'
  },
  sponsor: {
    label: 'Sponsor',
    emoji: '🏢',
    icon: Building,
    color: '#5D4037',
    group: 'Vendors & Business'
  },
  art: {
    label: 'Art',
    emoji: '🎨',
    icon: Palette,
    color: '#EC407A',
    group: 'Vendors & Business'
  },
  exhibition: {
    label: 'Exhibition',
    emoji: '🖼️',
    icon: Image,
    color: '#AB47BC',
    group: 'Vendors & Business'
  },

  // ============================================
  // EXPERIENCE
  // ============================================
  lounge: {
    label: 'Lounge',
    emoji: '🛋️',
    icon: Armchair,
    color: '#5C6BC0',
    group: 'Experience'
  },
  chill_zone: {
    label: 'Chill Zone',
    emoji: '🌴',
    icon: Palmtree,
    color: '#26A69A',
    group: 'Experience'
  },
  vip_lounge: {
    label: 'VIP Lounge',
    emoji: '⭐',
    icon: Crown,
    color: '#FFD700',
    group: 'Experience'
  },
  photo_spot: {
    label: 'Photo Spot',
    emoji: '📸',
    icon: Camera,
    color: '#42A5F5',
    group: 'Experience'
  },
  charging_station: {
    label: 'Charging Station',
    emoji: '🔋',
    icon: Zap,
    color: '#66BB6A',
    group: 'Experience'
  },
  networking: {
    label: 'Networking',
    emoji: '🤝',
    icon: Handshake,
    color: '#29B6F6',
    group: 'Experience'
  },

  // ============================================
  // FAMILY
  // ============================================
  kids: {
    label: 'Kids',
    emoji: '🧸',
    icon: Baby,
    color: '#00C853',
    group: 'Family'
  },
  family_zone: {
    label: 'Family Zone',
    emoji: '👨‍👩‍👧‍👦',
    icon: Home,
    color: '#00E676',
    group: 'Family'
  },

  // ============================================
  // SERVICES
  // ============================================
  restroom: {
    label: 'Restroom',
    emoji: '🚻',
    icon: CircleUserRound,  // ✨ Universal restroom/person icon
    color: '#2196F3',
    group: 'Services'
  },
  medical: {
    label: 'Medical',
    emoji: '🏥',
    icon: Stethoscope,
    color: '#E53935',
    group: 'Services'
  },
  security: {
    label: 'Security',
    emoji: '🛡️',
    icon: Shield,
    color: '#455A64',
    group: 'Services'
  },
  info: {
    label: 'Info',
    emoji: 'ℹ️',
    icon: Info,
    color: '#3F51B5',
    group: 'Services'
  },
  water_station: {
    label: 'Water Station',
    emoji: '💧',
    icon: Droplet,
    color: '#03A9F4',
    group: 'Services'
  },
  lost_and_found: {
    label: 'Lost & Found',
    emoji: '🔍',
    icon: Search,
    color: '#FFC107',
    group: 'Services'
  },

  // ============================================
  // NAVIGATION
  // ============================================
  entrance: {
    label: 'Entrance',
    emoji: '🚪',
    icon: DoorOpen,
    color: '#4CAF50',
    group: 'Navigation'
  },
  exit: {
    label: 'Exit',
    emoji: '🚶',
    icon: DoorClosed,
    color: '#F44336',
    group: 'Navigation'
  },
  parking: {
    label: 'Parking',
    emoji: '🅿️',
    icon: ParkingSquare,
    color: '#757575',
    group: 'Navigation'
  },
  shuttle: {
    label: 'Shuttle',
    emoji: '🚌',
    icon: Bus,
    color: '#FF9800',
    group: 'Navigation'
  },
  ticket_booth: {
    label: 'Ticket Booth',
    emoji: '🎫',
    icon: Ticket,
    color: '#9C27B0',
    group: 'Navigation'
  },
  vip_entrance: {
    label: 'VIP Entrance',
    emoji: '🌟',
    icon: Star,
    color: '#FFD700',
    group: 'Navigation'
  },

  // ============================================
  // FALLBACK
  // ============================================
  other: {
    label: 'Other',
    emoji: '📍',
    icon: MapPin,
    color: '#607D8B',
    group: 'Other'
  }
};

// Helper function to get categories by group
export const getCategoriesByGroup = () => {
  const grouped = {};
  
  Object.entries(CATEGORY_CONFIG).forEach(([key, config]) => {
    const group = config.group || 'Other';
    if (!grouped[group]) {
      grouped[group] = [];
    }
    grouped[group].push({ key, ...config });
  });
  
  return grouped;
};

// Helper function to get all category keys
export const getAllCategoryKeys = () => {
  return Object.keys(CATEGORY_CONFIG);
};

// Helper function to get category config by key
export const getCategoryConfig = (categoryKey) => {
  return CATEGORY_CONFIG[categoryKey] || CATEGORY_CONFIG.other;
};

// Export category groups in order
export const CATEGORY_GROUPS = [
  'Food & Drinks',
  'Entertainment',
  'Vendors & Business',
  'Experience',
  'Family',
  'Services',
  'Navigation',
  'Other'
];